/* eslint-disable import/no-cycle */
// eslint-disable-next-line import/no-cycle
import { FC } from 'react';

import { IFeaturedContentSideBySideBladeProps } from 'blades/featuredContentSideBySideBlade/@types';
import FeaturedContent from 'components/FeaturedContent';
import SectionWrapper from 'components/SectionWrapper';
import styles from './featuredContentSideBySide.module.sass';

const FeaturedContentSideBySide: FC<IFeaturedContentSideBySideBladeProps> = props => {
  const { featuredContentBlades } = props;
  return (
    <SectionWrapper hasBodyMargin={false} childClasses={styles.sideBySideContainer}>
      {featuredContentBlades.map(featuredContent => (
        <FeaturedContent key={featuredContent?.sys.id} {...featuredContent?.fields} />
      ))}
    </SectionWrapper>
  );
};

export default FeaturedContentSideBySide;
